<div
  class="relative shrink-0 z-[997] w-full flex h-18 items-center"
  style="background: transparent"
>
  <!-- The lockup on the left, everything else on the right. There is no
       context bar under this one: each page carries its own heading and its
       own way back. -->
  <div class="flex min-w-0 items-center gap-2">
    @if (showToggle()) {
      <ui-button
        icon="pi pi-bars"
        variant="ghost"
        (click)="onToggleMenu()"
      />
    }
    <ng-content select="[headerBrand]" />
  </div>

  <div class="flex items-center gap-2 ml-auto">
    <ng-content />
  </div>
</div>
